module.exports = __webpack_public_path__ + "static/media/country_yu.651ef72d.webp";